import React from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import isEqual from 'fast-deep-equal';
import ShippingMethodsRadioGroup from './ShippingMethodsRadioGroup';
import CartPlant from './CartPlant';
import AvatarImage from '../CommonComponents/AvatarImage';
import CustomLoader from '../CommonComponents/CustomLoader';
import { numberFormat } from '../../utils/helpers';
const classes = {
    nurseryItemWrapper: (theme) => ({
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(5.5, 2, 2),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1, 2, 2),
        },
    }),
    nurseryInfo: (theme) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        paddingLeft: theme.spacing(1.5),
    }),
    nurseryName: (theme) => ({
        '&.MuiTypography-body1': {
            color: theme.palette.blueColors.main,
            fontSize: theme.spacing(2.75),
            fontWeight: 'bold',
            lineHeight: '30px',
            letterSpacing: '0.06em',
        },
    }),
    plantPreviewImage: (theme) => ({
        width: 75,
        height: 75,
        fontSize: theme.spacing(2),
        fontWeight: 'bold',
        lineHeight: '20px',
        color: theme.palette.blueColors.main,
        backgroundColor: theme.palette.newGreyColors.main,
    }),
    nurseryInfoHeader: (theme) => ({
        paddingBottom: theme.spacing(1.25),
        borderBottom: `1px solid ${theme.palette.blueColors.main}`,
        marginBottom: theme.spacing(2),
        '&:hover': {
            cursor: 'pointer',
        },
    }),
    nurseryShppingInfo: (theme) => ({
        '&.MuiTypography-body1': {
            color: theme.palette.blueColors.main,
            paddingTop: theme.spacing(0.75),
            fontSize: theme.spacing(1.75),
            fontWeight: 400,
            lineHeight: '18px',
            letterSpacing: '0.06em',
        },
    }),
    divider: (theme) => ({
        margin: theme.spacing(1, 0),
        borderColor: theme.palette.blueColors.main,
        width: '100%',
    }),
    nurserySubtotal: (theme) => ({
        fontSize: theme.spacing(2),
        color: theme.palette.blueColors.main,
        lineHeight: '20px',
        fontWeight: 400,
    }),
    nurseryTotal: (theme) => ({
        fontSize: theme.spacing(2),
        color: theme.palette.blueColors.main,
        lineHeight: '20px',
        fontWeight: 'bold',
    }),
    nurseryTotalPrice: {
        fontWeight: 'bold',
    },
    nurseryItemWrapperCart: (theme) => ({
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(1, 2, 2),
    }),
};
class CartNursery extends React.Component {
    constructor(props) {
        super(props);
        this.setShippingPrice = (price, indexValue) => {
            const { updateNursery, nursery } = this.props;
            const updatedNursery = {
                ...nursery,
                selectedIndex: indexValue,
                shippingPrice: price,
            };
            if (updateNursery)
                updateNursery(updatedNursery, updatedNursery.shippingPrice);
        };
        this.removeItem = async (plant) => {
            const { changeQuantity, nursery } = this.props;
            this.setState({ shippingLoadingOverride: true });
            const newPlant = {
                ...plant,
                quantity: 0,
            };
            await changeQuantity(newPlant, nursery);
        };
        this.goToPlant = (plantURL) => {
            window.location.href = plantURL;
        };
        this.changeNurseryQuantity = async (plant) => {
            const { changeQuantity, nursery } = this.props;
            this.setState({ shippingLoadingOverride: true });
            await changeQuantity(plant, nursery);
        };
        this.state = {
            shippingLoadingOverride: false,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var _a;
        if (prevState.shippingLoadingOverride && !((_a = nextProps.nursery) === null || _a === void 0 ? void 0 : _a.shippingLoading)) {
            return { shippingLoadingOverride: false };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { updateNursery, nursery } = this.props;
        const nurseryChanged = !isEqual(prevProps.nursery, nursery);
        const needsShippingReset = !nursery.shipping_options
            && (nursery.shippingPrice !== 0 || nursery.selectedIndex !== undefined);
        if (needsShippingReset) {
            this.setShippingPrice(0);
            return;
        }
        if (nurseryChanged && updateNursery) {
            updateNursery(nursery, nursery.shippingPrice);
        }
    }
    render() {
        var _a;
        const { showTotals, shopifyCart, nursery, selectedNurseries, } = this.props;
        const { shippingLoadingOverride } = this.state;
        const shippingLoading = shippingLoadingOverride || (nursery === null || nursery === void 0 ? void 0 : nursery.shippingLoading);
        if (nursery) {
            return (React.createElement(Grid, { container: true, justifyContent: "center", direction: "column", sx: [classes.nurseryItemWrapper,
                    shopifyCart && classes.nurseryItemWrapperCart] },
                React.createElement(Grid, { container: true, justifyContent: "flex-start", wrap: "nowrap", sx: classes.nurseryInfoHeader, onClick: () => this.goToPlant(`/nurseries/${nursery.shopify_handle}/`) },
                    React.createElement(AvatarImage, { key: nursery.name, customClassName: classes.plantPreviewImage, src: nursery.avatar, alt: nursery.name }),
                    React.createElement(Grid, { sx: classes.nurseryInfo },
                        React.createElement(Typography, { sx: classes.nurseryName }, nursery.name),
                        React.createElement(Typography, { sx: classes.nurseryShppingInfo }, nursery.shipping_info_long !== '' ? nursery.shipping_info_long : nursery.shipping_info))),
                React.createElement(Grid, { container: true, justifyContent: "flex-start" }, (_a = nursery === null || nursery === void 0 ? void 0 : nursery.items) === null || _a === void 0 ? void 0 :
                    _a.map((plant) => (React.createElement(CartPlant, { key: `${plant.name}-${plant.shopify_title}`, plant: plant, shopifyCart: shopifyCart, goToPlant: this.goToPlant, removeItem: this.removeItem, changeNurseryQuantity: this.changeNurseryQuantity }))),
                    showTotals && nursery.shipping_options && (React.createElement(ShippingMethodsRadioGroup, { methods: nursery.shipping_options, setShippingPrice: this.setShippingPrice, selectedNurseries: selectedNurseries })),
                    React.createElement(Divider, { sx: classes.divider }),
                    React.createElement(Grid, { container: true, justifyContent: "space-around", direction: "column" },
                        React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between" },
                            React.createElement(Typography, { sx: classes.nurserySubtotal }, !showTotals ? `${nursery.name} subtotal` : 'Nursery subtotal'),
                            shippingLoading && !shopifyCart ? (React.createElement(CustomLoader, { key: nursery.name, loaderSx: null, loaderAttributes: { size: 20, thickness: 5 } })) : (React.createElement(Typography, null,
                                "$",
                                numberFormat(nursery.subtotal)))),
                        showTotals && (React.createElement(React.Fragment, null,
                            React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between" },
                                React.createElement(Typography, { sx: classes.nurserySubtotal }, "Nursery shipping"),
                                shippingLoading ? (React.createElement(CustomLoader, { key: nursery.name, loaderSx: null, loaderAttributes: { size: 20, thickness: 5 } })) : (React.createElement(Typography, null,
                                    "$",
                                    numberFormat(nursery.shippingPrice)))),
                            React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between" },
                                React.createElement(Typography, { sx: classes.nurseryTotal }, "Nursery total"),
                                shippingLoading ? (React.createElement(CustomLoader, { key: nursery.name, loaderSx: null, loaderAttributes: { size: 20, thickness: 5 } })) : (React.createElement(Typography, { sx: classes.nurseryTotalPrice },
                                    "$",
                                    numberFormat(nursery.total))))))))));
        }
        return null;
    }
}
export default CartNursery;
